<div class="mobile-backdrop" [class.visible]="mobileMenuExpanded$ | async" (click)="closeMobileMenu()" aria-hidden="true"></div>
<div
  class="main-sidebar"
  [class.expanded]="!isCollapsed"
  [class.hidden]="isCollapsed"
  [class.icon-strip]="showIconsWhenCollapsed"
  [class.mobile-open]="mobileMenuExpanded$ | async"
  role="navigation"
  [attr.aria-label]="'translations.global.ariaLabels.secondaryNavigation' | transloco"
>
  <button
    type="button"
    class="edge-toggle"
    [attr.aria-label]="
      (isCollapsed ? 'translations.global.ariaLabels.expandSidebar' : 'translations.global.ariaLabels.collapseSidebar') | transloco
    "
    [attr.aria-expanded]="!isCollapsed"
    (click)="onToggleCollapse()"
  >
    <ptl-icon [icon]="isCollapsed ? LucideChevronRight : LucideChevronLeft" [size]="'s'" [color]="'currentColor'"></ptl-icon>
  </button>
  <div class="sidebar-content">
    <div class="navigation-items-container">
      <div class="collapse-menu-container" [class.collapse-menu-container--hide-on-mobile]="hideCollapseMenuOnMobile">
        @if (backLink) {
          <a class="back-link" [class.hidden]="isCollapsed" [routerLink]="backLink.url" [queryParams]="backLink.queryParams ?? null">
            <ptl-icon [icon]="LucideChevronLeft" [size]="'s'"></ptl-icon>
            <span>{{ backLink.label }}</span>
          </a>
        }
      </div>

      <div
        class="nav-content"
        [class.hidden]="isCollapsed && !showIconsWhenCollapsed"
        [class.icons-only]="isCollapsed && showIconsWhenCollapsed"
      >
        @if (type || title) {
          <div class="sidebar-title-container">
            <div *ngIf="type" class="sidebar-type fs-body-xs">
              <span class="title-text">{{ type }}</span>
            </div>
            <div *ngIf="title" class="sidebar-title fs-body-m semibold">
              @if (titleUrl) {
                <a class="title-text title-link" [routerLink]="titleUrl">{{ title }}</a>
              } @else {
                <span class="title-text">{{ title }}</span>
              }
            </div>
          </div>
        }
        <div class="sidebar-projected-content">
          <ng-content></ng-content>
        </div>

        <div class="sidebar-projected-footer">
          <ng-content select="[sidebarFooter]"></ng-content>
        </div>
      </div>
    </div>
  </div>
</div>
